export const registrationSelector = (state) => ({
  registration: state.registration
});
